import ProductTitleCard from './productTitleCard.container';

export default ProductTitleCard;